enum Permissions {
  Trx_recaudo_directo_gases_del_caribe = 8004,
  Trx_recaudo_directo_acueducto = 8003,
  Trx_recaudo_directo = 8001,
  Trx_retiro_directo = 8002,
  Gestion_recaudo_retiro_directo = 8000,
}
export default Permissions;
